import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ConsentScreen = lazy(() =>
  import("./consent-screen.js").then((m) => ({ default: m.ConsentScreen })),
);

function Consent() {
  return (
    <Suspense fallback={null}>
      <ConsentScreen />
    </Suspense>
  );
}

/**
 * "Sign in with Crux": where an app sends a person to connect it. Public like
 * an invite; signed out, it sends them to sign in and back (DESIGN.md "Sign
 * in with Crux"). The parent is a type parameter so the tree keeps its types.
 */
export function consentRoute<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/oauth/authorize",
    component: Consent,
  });
}
